// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { getMatch } from './getMatch.mjs';

// Local Functions
const getModules = createSelector(
  [getMatch, () => {}],
  // TODO: implement selector that resolves modules from entity metadata
  (match, data) => ({ ...match, ...data }),
);

// Module Exports
export { getModules };
